import React from "react";
import landscape from "../../../assets/Image/pokemon-grass-battle-background.jpg";
import { FaRegHeart } from "react-icons/fa";


const CollectionCard = () => {
  return (
    <div className="rounded-xl shadow-md shadow-black cursor-pointer bg-white relative">
      <div className="overflow-hidden rounded-t-xl border-b-6 border-slate-200 h-32">
        <img src={landscape} alt="" className="object-cover" />
      </div>
      <div className="flex justify-between items-center py-4 px-2">
        <p>
          Pokemon Card
        </p>
        <p>
          0%
        </p>
        <p className="font-extrabold">
          $0.00 /$388.33
        </p>
      </div>

      <div className="absolute top-0 right-0 text-pinkColor w-14 h-14 bg-white flex justify-center items-center bg-opacity-40 m-2 rounded-full">
      <FaRegHeart className="w-8 h-auto"/>
      </div>

    </div>
  );
};

export default CollectionCard;
